import React, { useState, useEffect, Fragment } from 'react';
import { ListLayout } from '../../containers/Layout';

import Dialog from '../../../../../commonModules/interface/Dialog';
import FormPrepa from '../../sales/FormPrepa';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Menu, MenuItem, Typography, Checkbox, TableSortLabel } from '@material-ui/core';
import DeleteDialogConfirm from '../../../../../commonModules/interface/DeleteDialogConfirm';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import { AddRounded, CheckRounded, CloseRounded, DeleteRounded, AddBoxRounded, MoreVertRounded, IndeterminateCheckBoxOutlined } from '@material-ui/icons';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size, sumBy, sum } from 'lodash';
import ClientPopUp from '../../clients/ClientPopUp';
import SingleSaleCredits from '../../credits/SingleSaleCredits';
import FormCredit from '../../credits/FormCredit';
import { amber, cyan, deepPurple, indigo, red } from '@material-ui/core/colors';
import Currency from '../../../../../commonModules/Currency';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { generateTransferPDF } from '../../../../../../../../jsx/utils/transferPDFGenerator';

const ListTransferQuote = (props) => {
    const dispatch = useDispatch();
    const fetchTransfers = useFetchTransfers(props.dataview);
	const SHOPS = useSelector((state) => state.inventory.shops); 
	const CLIENTS = useSelector((state) => state.inventory.clients); 
	const QUOTES = useSelector((state) => state.inventory.quotes.QUOTES); 
	const AGENTS = useSelector((state) => state.agents.agents); 
	const PRODUCTS = useSelector((state) => state.inventory.products);
	const STATE = useSelector((state) => state.inventory.requestState); 

    const [dialogPrepa, setDialogPrepa] = useState(false);
    const [dialogDeletePrepa, setDialogDeletePrepa] = useState(false);
    const [prepa, setPrepa] = useState({
        id: "",
        nature: "payg"
    });
    const [breadcrumb, setBreadcrumb] = useState("");

    const [deletePopUp, setDeletePopUp] = useState(false);
    const [toDelete, setToDelete] = useState({
        id: ""
    });
    const [mdpAdmin, setMdpAdmin] = useState("");
    const [errors, setErrors] = useState({
        mdpAdmin: "",
    });

    const [filteredList, setFilteredList] = useState([]);

    const [view, setView] = useState("list");
    const [clientPopUp, setClientPopUp] = useState(false);
    const [sale, setSale] = useState({});
    const [client, setClient] = useState({});
    const [openMenu, setOpenMenu] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [newPayment, setNewPayment] = useState(false);
    const [paymentsDetails, setPaymentsDetails] = useState(false);
    const [parts, setParts] = useState({});
    const [totalPay, setTotalPay] = useState(0);
    const [incomeID, setIncomeID] = useState(0);
    const [downloadingPDF, setDownloadingPDF] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [sortDSC, setSortDSC] = useState(false);
    const [saleList,setSaleList]= useState({});

    useEffect(() => {
        console.log("MOUNTING ListTransferQuote ");
        if(isEmpty(QUOTES) && props.dataview === "quote"){
            fetchTransfers();
        }
    }, []);
    useEffect(() => {
        console.log("UPDATE QUOTES LIST",QUOTES)
        if (!isEmpty(QUOTES)){
			const saleList = displayList();
		    setSaleList(saleList)
		}
    }, [QUOTES]);
    useEffect(() => {
        const saleList = displayList();
		setSaleList(saleList)
    }, [checkedPayments]);

    const handleClick = (event, payID) => {
        const selectedIndex = checkedPayments.indexOf(payID);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedPayments, payID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedPayments.slice(1));
        } else if (selectedIndex === checkedPayments.length - 1) {
            newSelected = newSelected.concat(checkedPayments.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedPayments.slice(0, selectedIndex),
                checkedPayments.slice(selectedIndex + 1),
            );
        }

        setCheckedPayments(newSelected);
        setTotalPay(calcTotal(newSelected));
    };

    const handleSelectAllClick = (event, list) => {
        const { rowsPerPage, currentPage } = props;
        console.log("handleSelectAllClick >>",event.target.checked)

        if (event && event.target.checked) {
            let newList = list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
            .filter(ID => QUOTES[ID].match_available && QUOTES[ID].nature !== "payg" && !QUOTES[ID].sale_credit)
            setCheckedPayments(newList);
            setAllChecked(true);
            return;
        }
        setAllChecked(false);
        setCheckedPayments([]);
        setTotalPay(0);
        setIncomeID("");
    };

    const createSaleList = (list) => {
        const { rowsPerPage, currentPage } = props;
        console.log('====================================');
        console.log({list});
        console.log({QUOTES});
        console.log({ rowsPerPage, currentPage });
        console.log('====================================');
        const isSelected = name => checkedPayments.indexOf(name) !== -1;
        const BCKG = income_id => !!income_id ? amber[50] : 'initial';

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((sale, index) => {
            if (sale) {
                const client = CLIENTS[sale.client_id];
                const shop = SHOPS[sale.shop_id];
                const agent = AGENTS && AGENTS[sale.commercial_id];
                return (
                    <TableRow key={sale.id} 
                    style={{ 
                        backgroundColor: sale.sale_waiting_payment ? deepPurple[50] : BCKG(sale.fact_id_5000),
                        textDecoration: sale.is_deleted ? "line-through" : undefined,
                        color: sale.is_deleted ? "grey" : undefined,
                        fontStyle: sale.is_deleted ? "italic" : undefined,
                        textDecorationThickness: sale.is_deleted ? "2px" : "auto"
                    }}
                    >
                        <TableCell
                            padding="checkbox"
                        >
                            {sale.match_available && sale.nature !== "payg" && !sale.sale_credit &&
                                <Checkbox
                                    onClick={event => handleClick(event, sale.id)}
                                    checked={isSelected(sale.id)}
                                    inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                                />
                            }
                        </TableCell>
                        <TableCell>{(new Date(sale.creation_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            {shop ? (
                                <a href="#" onClick={() => props.handleSingleShop(shop)}> {shop.name} </a>
                            ) : (
                                <span>{sale.shop_id}</span>
                            )}
                        </TableCell>
                        <TableCell>{client &&
                            <a href="#" onClick={() => {setClient(client); setClientPopUp(true)}}>{client.client_firstname} {client.client_lastname}</a>
                        }
                        </TableCell>
                        <TableCell><Currency value={sale.total_price} /></TableCell>
                        <TableCell>
                            <IconButton
                                color="secondary"
                                onClick={() => props.handleSingleSale(sale, shop, client, agent)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            {sale.sale_credit &&
                                <Fragment>
                                    <IconButton
                                        aria-controls={`option-menu${sale.id}`}
                                        aria-haspopup="true"
                                        onClick={event => {setAnchorEl(event.currentTarget); setOpenMenu(sale.id)}}
                                    >
                                        <MoreVertRounded fontSize="small" />
                                    </IconButton>
                                    <Menu
                                        id={`option-menu${sale.id}`}
                                        anchorEl={anchorEl}
                                        getContentAnchorEl={null}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={openMenu === sale.id}
                                        onClose={() => {setOpenMenu(""); setAnchorEl(null)}}
                                    >

                                        {sale.nature !== "prepa" && sale.shop_id !== "Commercial" &&
                                           <MenuItem onClick={() => {
                                                setToDelete(sale);
                                                setDeletePopUp(true);
                                            }}>
                                                Supprimer
                                            </MenuItem>
                                        }
                                    </Menu>
                                </Fragment>
                            }

                            {sale.nature !== "prepa" && sale.shop_id !== "Commercial" && !sale.sale_credit && !sale.is_deleted &&
                                <IconButton onClick={() => {
                                    setToDelete(sale);
                                    setDeletePopUp(true);
                                }}>
                                    <DeleteRounded color="error" />
                                </IconButton>
                                
                            }
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        let listAll = [];
        let tab = [];
        let rows = 0;
        if (!isEmpty(QUOTES)) {
            let filteredList = props.getFilteredList();
            rows = size(filteredList);
            tab = createSaleList(filteredList);
            listAll = filteredList.map(sale => sale.id);
        }
        return { list: tab, size: rows, listAll };
    };

  
    const arrayEqual = (arr1, arr2) => {
        const arr2Sorted = arr2.slice().sort();
        return arr1.length === arr2.length &&
            arr1.slice().sort().every((value, index) => value === arr2Sorted[index]);
    };


    const calcTotal = (list) => {
        console.log('=============CALC TOTAL=======================');
        console.log({list});
        console.log('====================================');
        return sumBy(list, (saleID) => QUOTES[saleID].total_available);
    };

    const calcTotalV2 = (list) => {
        return sumBy(list, (saleID) => parts[saleID]);
    };

    const handleBulkDownloadQuotes = async () => {
        if (downloadingPDF || size(checkedPayments) === 0) return;
        setDownloadingPDF(true);
        let successCount = 0;
        let errorCount = 0;
        try {
            for (const quoteId of checkedPayments) {
                const quote = QUOTES[quoteId];
                if (!quote) continue;
                const shop = SHOPS[quote.shop_id];
                const client = CLIENTS[quote.client_id] || {};
                if (!shop) {
                    toast.error(`Magasin manquant pour la cotation ${quote.intern_ref_id || quoteId}`);
                    errorCount++;
                    continue;
                }
                try {
                    const transferDetails = await dispatch(fetchTransferDetails(quoteId));
                    await generateTransferPDF({
                        transferDetails,
                        shop,
                        client,
                        products: PRODUCTS || {},
                        options: { showTVA: true, currency: 'FCFA' },
                    });
                    successCount++;
                } catch (err) {
                    console.error('[ERROR] PDF download failed for quote', quoteId, err);
                    toast.error(`Erreur pour ${quote.intern_ref_id || quoteId}: ${err.message}`);
                    errorCount++;
                }
            }
            if (successCount > 0) {
                toast.success(`${successCount} cotation(s) téléchargée(s)`);
            }
            if (errorCount > 0 && successCount === 0) {
                toast.error('Aucune cotation téléchargée');
            }
        } finally {
            setDownloadingPDF(false);
        }
    };

    const deleteSale = async () => {

        try{
            const resp = await props.deleteSale(toDelete);
            toast.success("Cotation supprimée avec succès");
            setDeletePopUp(false);
            setToDelete({ id: "" });
            setOpenMenu("");
            setAnchorEl(null);
        }catch(err){
            console.log("[ERROR] delete sale", err.message);
            toast.error("Un Problème est survenu"+err.message);
        }
    };


    return (
        <>
            {deletePopUp &&
                <DeleteDialogConfirm
                        title={"la cotation n°" + toDelete.id}
                        handleSubmit={deleteSale}
                        block={true}
                        close={() => setDeletePopUp(false)}
                 />
            }

            {dialogPrepa &&
                <FormPrepa
                    {...props}
                    prepa={prepa}
                    handleClose={() => setDialogPrepa(false)}
                />
            }
            {paymentsDetails &&
                <SingleSaleCredits
                    title="Liste des paiement"
                    sale={sale}
                    client={client}
                    {...props}
                    closePopUp={() => setPaymentsDetails(false, setSale({}, setClient({})))}
                />
            }
            {newPayment &&
                <FormCredit
                    sale={sale}
                    client={client}
                    {...props}
                    closePopUp={() => setNewPayment(false, setSale({}, setClient({})))}
                />
            }
            {clientPopUp && !isEmpty(client) &&
                <ClientPopUp
                    client={client}
                    {...props}
                    closePopUp={() => setClientPopUp(false, setClient({}))}
                />
            }

            {size(checkedPayments) > 0 &&
                <Button variant="contained" color="primary" onClick={handleBulkDownloadQuotes} disabled={downloadingPDF}>
                    {downloadingPDF ? 'Téléchargement...' : `Télécharger ${size(checkedPayments)} cotation`}
                </Button>
            }

            {view === "list" && (
                <Box>
                    <Box>
                        <Box p={1}>
                            <Typography variant="h6">Liste des cotations</Typography>
                        </Box>
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < saleList.size}
                                            checked={allChecked}
                                            onChange={(e) => handleSelectAllClick(e, saleList.listAll)}
                                            inputProps={{ 'aria-label': 'Selectionner tout' }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        Date
                                    </TableCell>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Nom Client</TableCell>
                                    <TableCell>Montant</TableCell>
                                    <TableCell>Détails</TableCell>
                                    <TableCell>Options</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { saleList.size !== 0  && 
                                    saleList.list
                                }
                                { saleList.size === 0  && 
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <div className="text-center">
                                            Cliquez sur{' '}
                                            <Button
                                                color="primary"
                                                className="text-right"
                                                // onClick={() => {
                                                //     setShowNew(true); 
                                                //     setBreadcrumb('Nouveau');
                                                //     // setState({ ...state, showNew: true, breadcrumb: 'Nouveau' });
                                                // }}
                                            >
                                                Nouveau
                                            </Button>{' '}
                                            pour entrer une nouvelle Cotation
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            { saleList.size > 20  && 
                                <TableFooterPagination 
                                    colSpan={7}
                                    // items={saleList[0]} 
                                    count={saleList.size}
                                    onChangePage={props.onChangePage}
                                    initialPage={props.currentPage || 0}
                                    page={props.currentPage}
                                />         
                            }           
                        </ListLayout>
                    </Box>
                </Box>
            )}
        </>
    );
}

export default ListTransferQuote;